<template>
    <div class="freeword">
        <h1 v-html="question.question"></h1>
        <textarea v-model="text" rows="4" cols="50" placeholder="Írd be válaszod" v-on:input="textChanged()"></textarea>


    </div>
</template>

<script>
export default {
    data: () => {
        return {
            text: '',
            that: this,
           }   
    },
    props: [
        'question'
    ],
    mounted(){
         this.$store.state.buttonDisabled = false;
    },
    methods: {
        textChanged() {
            if(this.text !== ''){
                this.$store.state.buttonDisabled = true;
            } else {
                this.$store.state.buttonDisabled = false;
            }
        }
    },
    beforeDestroy() {
        var endDateSaveData = {
            'session_questions_fk': this.question.session_questions_id,
            'user_answer' : this.text,
            'type' : this.question.type,
        }
        this.axios.put('/backend/web/end-question?access-token='+this.$store.state.privateKey, endDateSaveData);    
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .freeword{
        h1{
            font-size: 21px;
            margin-bottom: 40px;
        }
    }
</style>